import AxiosProvider from '@/app/utils/api/axios-provider';
import { AxiosResponse } from 'axios';

export default {
  getClients(): Promise<AxiosResponse> {
    return AxiosProvider.amsApiClient.get('/clients');
  },
};
